import { render, staticRenderFns } from "./SysLanguageConfigFileForm.vue?vue&type=template&id=4ddba422&"
import script from "./SysLanguageConfigFileForm.vue?vue&type=script&lang=js&"
export * from "./SysLanguageConfigFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports